import { skipToken } from '@reduxjs/toolkit/query'

import { useGetQRAAssessmentQuery } from 'app/services/api/qra/assessments'
import {
  IQRAChartObjects,
  IQRARiskForecastChartObject,
  QRAGraphType
} from '../../Components/Graphs'
import GraphsView from '../../Components/Graphs/Layout/SystemView'

interface GraphsViewWrapperProps {
  showLoading: boolean
  charts?: IQRAChartObjects
  hasLineViewNavigation: boolean
  qraBasePath: string
  qraViewBasePath: string
  assessmentId?: string
}

const GraphsViewWrapper = ({
  showLoading,
  charts = {},
  hasLineViewNavigation,
  qraBasePath,
  qraViewBasePath,
  assessmentId
}: GraphsViewWrapperProps) => {
  const { currentAssessment } = useGetQRAAssessmentQuery(
    assessmentId ?? skipToken,
    {
      selectFromResult: (result) => ({
        currentAssessment: result.currentData
      })
    }
  )

  const getRiskForecastItems = () => {
    const chartObject = charts[QRAGraphType.RISK_FORECAST]
    const riskForecastChartObject = chartObject as IQRARiskForecastChartObject

    if (currentAssessment) {
      return riskForecastChartObject?.items.filter(
        (item) => item.year >= currentAssessment.fromForecastYear
      )
    }
  }

  const itemsFromGraphType = {
    [QRAGraphType.RISK_FORECAST]: getRiskForecastItems
  }

  return (
    <GraphsView
      qraBasePath={qraBasePath}
      qraViewBasePath={qraViewBasePath}
      showLoading={showLoading}
      charts={charts}
      hasLineViewNavigation={hasLineViewNavigation}
      itemsFromGraphType={currentAssessment && itemsFromGraphType}
    />
  )
}

export default GraphsViewWrapper
